import React from "react";

const ObaListComp = ()=>{

    return (
        <div>List</div>
    );

};

export default ObaListComp;